module.exports = __webpack_public_path__ + "img/background.2ee0ae40.svg";